import React from 'react';
import {AbsoluteFill} from 'remotion';
import {bgGradient} from '../brand';

export const BgGradient: React.FC = () => (
  <AbsoluteFill style={{backgroundImage: bgGradient}} />
);
